import { Injectable, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { MatchError } from '../errors/error-matcher';
import { LoggingHandler } from '../errors/logging.service';

@Injectable({ providedIn: 'root' })
export class Permissions {
  constructor(
    protected router: Router,
    protected authenticationService: AuthenticationService,
    protected matchError: MatchError,
    protected loggingHandler: LoggingHandler
  ) {}

  async canActivate(): Promise<boolean> {
    if (this.authenticationService.isLoggedIn()) {
      return true;
    }
    this.router.navigate([`/`]);
    return false;
  }
}

export const AuthGuard: CanActivateFn = (): Promise<boolean> => {
  return inject(Permissions).canActivate();
};
